<template>
  <div class="page-content" style="margin-top: 20px">
    <el-row class="sign-manage-title search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">模板消息</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div form-submit-page">
        <el-form :model="formInline" :rules="rules" ref="formInline" label-width="160px" style="margin-top: 20px;" class="box-content-form">
          <!-- <p>注意：模板内容长度不能超过200个字符，且必须有至少10个固定文字或标点。<br>建议发送前进行测试预览。</p> -->
          <el-form-item label="模板消息名称:" prop="message_title">
            <div style="display: flex; justify-content: flex-start; flex-direction: row;">
              <el-input v-model="formInline.message_title" placeholder=""></el-input>
                <el-tooltip class="item" effect="dark" content="注意：模板内容长度不能超过200个字符，且必须有至少10个固定文字或标点。建议发送前进行测试预览。" placement="bottom">
                <i class="el-icon-question" style="margin-top: 10px; margin-left: 5px;"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="第一句:" prop="first">
            <el-input v-model="formInline.first" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="item.name" v-for="(item, index) of contentArr" :key='item.index' prop="first">
            <el-input v-model="formData[index]" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="最后一句:" prop="remark">
            <el-input v-model="formInline.remark" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="详情地址(可选):">
            <el-radio-group v-model="formInline.click_type">
              <el-radio label="1">跳转网页</el-radio>
              <el-radio label="2">跳转小程序</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="网址:" v-if='formInline.click_type == 1' class="web-adress">
            <el-input v-model="formInline.web_url" placeholder="请输入">
              <template slot="prepend">Http://</template>
            </el-input>
          </el-form-item>
          <div v-if='formInline.click_type == 2'>
            <el-form-item label="小程序:">
              <el-input v-model="formInline.program_name" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="小程序路径:">
              <el-input v-model="formInline.program_url" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="备用网页(可选):">
              <el-input v-model="formInline.program_url_back" placeholder=""></el-input>
              <p>(旧版微信客户端无法支持小程序，用户点击时将打开该网页)</p>
            </el-form-item>
          </div>
          <el-form-item label="" style="text-align: left;">
            <el-button class="next-step-btn" style="float: none;margin-left: 0px" @click='goBack'>返回</el-button>
            <el-button class="confirm-btn" style="float: none;margin-left:32px" @click="getForm('formInline')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
import { messageAddTrue, messageDetail, messageDeit } from '@/api/customer.js'
export default {
  name: 'templateMessageAdd',
  data () {
    return {
      contentArr: this.$route.query.contentArr,
      id: this.$route.query.id,
      detail: false,
      formInline: {
        message_title: '',
        first: '',
        web_url: '',
        remark: '',
        click_type: '1',
        program_name: '',
        program_url: '',
        program_url_back: '',
        template_id: this.$route.query.template_id,
        original_id: this.$route.query.original_id
      },
      formData: [],
      rules: {
        message_title: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ],
        first: [
          { required: true, message: '请输入第一句', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入最后一句', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (typeof (this.id) !== 'undefined') {
      this.getById()
      this.detail = true
    }
    console.log(this.$route.query.contentArr)
  },
  methods: {
    getForm() {
      this.$refs['formInline'].validate((valid) => {
        if (valid) {
          for (let i in this.contentArr) {
            this.formInline[this.contentArr[i].field] = this.formData[i]
            if (this.formData[i] === '' || this.formData[i] === undefined) {
              _g.toastMsg('error', '模板消息内容不能为空')
              return
            }
          }
          this.messageAddTrue()
        } else {
          // _g.toastMsg('error', '请输入模板名称')
          return false
        }
      })
    },
    // 详情
    getById() {
      let data = {
        id: this.id
      }
      messageDetail(data).then((res) => {
        if (res.data.code === 0) {
          console.log(res.data)
          let message = res.data.data.message
          let content = res.data.data.content
          this.formInline.message_title = message.message_title
          this.formInline.first = content.first
          this.formInline.web_url = message.web_url
          this.formInline.remark = content.remark
          this.formInline.click_type = message.click_type + ''
          this.formInline.program_name = message.program_name
          this.formInline.program_url = message.program_url
          this.formInline.program_url_back = message.program_url_back
          this.formInline.template_id = message.template_id
          this.contentArr = res.data.data.contentArr
          for (let item of this.contentArr) {
            let field = item.field
            this.formData.push(content[field])
          }
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 添加
    messageAddTrue() {
      let data = this.formInline
      if (typeof (this.id) !== 'undefined') {
        data.id = this.id
        messageDeit(data).then((res) => {
          if (res.data.code === 0) {
            console.log(res.data)
            _g.toastMsg('success', '编辑成功')
            this.goBack()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      } else {
        messageAddTrue(data).then((res) => {
          if (res.data.code === 0) {
            console.log(res.data)
            _g.toastMsg('success', '添加成功')
            this.goBack()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  created() {
  }
}
</script>

<style scoped>
.green{
  color: green;
}
.red{
  color: red;
}
.add-btn{
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
  width: 600px;
  margin: auto;
}
.box-content-form {
  margin-top: 10px;
  text-align: center;
  width: 600px;
  margin: 0 auto;
}
.box-content-form .el-form-item {
  width: 600px;
  text-align: center;
}
</style>
